import { render, staticRenderFns } from "./FeedbackSetting.vue?vue&type=template&id=6ca1acec&scoped=true&"
import script from "./FeedbackSetting.vue?vue&type=script&lang=js&"
export * from "./FeedbackSetting.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackSetting.vue?vue&type=style&index=0&id=6ca1acec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca1acec",
  null
  
)

export default component.exports